function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawNoteList = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 974 805.02",
    style: style
  }, props), React.createElement("path", {
    d: "M974 768.75v5a19.11 19.11 0 0 1-20.91 19c-39.15-3.72-78.12-10.64-117.4-9.43-72.42 2.21-145.44 31.83-215.54 13.53-19.77-5.16-39.32-14.13-59.66-12.2-18.25 1.73-34.49 12.05-52.17 16.89C454.55 816.3 399.8 779 344.06 780.51c-36.74 1-71.92 18.89-108.62 16.9-21.27-1.14-41.53-8.92-62.28-13.71-51.66-11.94-104.86-5.27-158.09-1.13A14 14 0 0 1 0 768.64v-4.28a14 14 0 0 1 14-14l940.92-.76A19.11 19.11 0 0 1 974 768.75z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M974 768.75v5a19.11 19.11 0 0 1-20.91 19c-39.15-3.72-78.12-10.64-117.4-9.43-72.42 2.21-145.44 31.83-215.54 13.53-19.77-5.16-39.32-14.13-59.66-12.2-18.25 1.73-34.49 12.05-52.17 16.89C454.55 816.3 399.8 779 344.06 780.51c-36.74 1-71.92 18.89-108.62 16.9-21.27-1.14-41.53-8.92-62.28-13.71-51.66-11.94-104.86-5.27-158.09-1.13A14 14 0 0 1 0 768.64v-4.28a14 14 0 0 1 14-14l940.92-.76A19.11 19.11 0 0 1 974 768.75z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M974 759.61v5a20.39 20.39 0 0 1-.11 2.08 19.11 19.11 0 0 1-20.8 17c-39.15-3.73-78.12-10.65-117.4-9.44-72.42 2.22-145.44 31.84-215.54 13.53-19.77-5.16-39.32-14.13-59.66-12.2-18.25 1.73-34.49 12.05-52.17 16.9-53.77 14.72-108.52-22.58-164.26-21.08-36.74 1-71.92 18.89-108.62 16.91-21.27-1.15-41.53-8.92-62.28-13.72-51.65-11.93-104.86-5.26-158.09-1.12a14 14 0 0 1-14.86-11.5 13.7 13.7 0 0 1-.21-2.46v-4.28a14 14 0 0 1 14-14l235.83-.19 481.81-.4 223.28-.18A19.11 19.11 0 0 1 974 759.61z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M743.59 743.51c0 2.21-4.36 4.33-12.4 6.32-32.19 7.95-123.19 13.68-230.6 13.68-105.67 0-195.58-5.55-229-13.31-9-2.09-14-4.34-14-6.69 0-.82.6-1.63 1.78-2.43l481.81-.4c1.59.93 2.41 1.83 2.41 2.83z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.5
  }, React.createElement("rect", {
    x: 552,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#36334a"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M601 26h93v21h-93z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M601 60h285v11H601zM601 84h114v11H601z"
  })), React.createElement("g", {
    opacity: 0.5
  }, React.createElement("rect", {
    x: 48,
    y: 98.51,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#36334a"
  }), React.createElement("path", {
    fill: "#36334a",
    d: "M97 124.51h93v21H97zM97 158.51h285v11H97zM97 182.51h114v11H97z"
  }), React.createElement("rect", {
    x: 48,
    y: 98.51,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#36334a"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M97 124.51h93v21H97z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M97 158.51h285v11H97zM97 182.51h114v11H97z"
  })), React.createElement("rect", {
    x: 667.58,
    y: 211.54,
    width: 10.31,
    height: 85.02,
    rx: 2.29,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 324.76,
    y: 144.93,
    width: 5.79,
    height: 27.99,
    rx: 1.5,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 324.55,
    y: 196.17,
    width: 6.52,
    height: 48.72,
    rx: 1.69,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 324.65,
    y: 261.94,
    width: 6.21,
    height: 49.14,
    rx: 1.61,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 328.04,
    y: 52.43,
    width: 345.1,
    height: 701.37,
    rx: 35.69,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 467.3,
    y: 73.38,
    width: 48.19,
    height: 9.79,
    rx: 2.54,
    fill: "#e6e8ec"
  }), React.createElement("circle", {
    cx: 528.33,
    cy: 78.27,
    r: 5.55,
    fill: "#e6e8ec"
  }), React.createElement("path", {
    d: "M651.83 98.11v610a27.41 27.41 0 0 1-27.41 27.4H376.76a27.41 27.41 0 0 1-27.41-27.4v-610a27.41 27.41 0 0 1 27.41-27.41h37.06v4.81a22.58 22.58 0 0 0 22.57 22.57h126a22.57 22.57 0 0 0 22.52-22.57v-4.76h39.51a27.41 27.41 0 0 1 27.41 27.36z",
    fill: "#36334a"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M358 129h31v4h-31zM358 136h31v4h-31zM358 143h31v4h-31z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M358 129h31v4h-31zM358 136h31v4h-31zM358 143h31v4h-31zM637.66 139h-.91l-.35-.29a7.61 7.61 0 0 0 1.78-4.89 7.44 7.44 0 1 0-7.4 7.48 7.73 7.73 0 0 0 4.88-1.78l.34.29v.92l5.74 5.75 1.72-1.72zm-6.88 0a5.18 5.18 0 1 1 5.16-5.18 5.15 5.15 0 0 1-5.16 5.18z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M358 200h93v21h-93z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M358 234h285v11H358zM358 258h114v11H358z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M358 444h93v21h-93z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M358 478h285v11H358zM358 502h114v11H358z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M358 566h93v21h-93z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M358 600h285v11H358zM358 624h114v11H358z"
  }), React.createElement("circle", {
    cx: 592,
    cy: 676,
    r: 34,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M609.33 673.32v16.43a1.25 1.25 0 0 1-1.25 1.25h-33.5a1.25 1.25 0 0 1-1.25-1.25v-26.17a1.25 1.25 0 0 1 1.25-1.25h23.31M579.67 672h22.66M580 676.67h22.67M580.33 681.33H603",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    fill: "none",
    stroke: "#f0f",
    strokeMiterlimit: 10,
    d: "M605 661v11.33M610.67 666.67h-11.34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M605 661v11.33M610.67 666.67h-11.34"
  }), React.createElement("path", {
    d: "M888.6 745.17c3-5.51-.4-12.27-4.29-17.18s-8.61-10-8.51-16.29c.15-9 9.7-14.31 17.33-19.09a84 84 0 0 0 15.56-12.51 22.8 22.8 0 0 0 4.78-6.4c1.58-3.52 1.54-7.52 1.44-11.37q-.51-19.26-1.91-38.49",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), React.createElement("path", {
    d: "M927.51 623.14a14 14 0 0 0-7-11.5l-3.14 6.22.1-7.53a14.22 14.22 0 0 0-4.63-.56 14 14 0 1 0 14.68 13.37zM902.48 718.13a14 14 0 1 1 .68-11.3l-8.77 7.13 9.65-2.23a14 14 0 0 1-1.56 6.4zM895.55 690.88a14 14 0 0 1-4.45-27.53l-.08 5.78 3.18-6.29a14 14 0 0 1 14.67 13.36 13.84 13.84 0 0 1-.6 4.79 14 14 0 0 1-12.72 9.89zM929.62 668.21a14 14 0 1 1 6.21-26.27l-2.48 6.8 5.1-4.9a14 14 0 0 1 4.55 9.67 13.79 13.79 0 0 1-.35 3.87 14 14 0 0 1-13.03 10.83z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M925.62 626.88c-3.24.35-6.39 1.36-9.64 1.56s-6.82-.57-8.88-3.1c-1.1-1.36-1.66-3.08-2.59-4.57a10 10 0 0 0-3.54-3.33 14 14 0 1 0 26.24 9.32q-.79.03-1.59.12zM929.62 668.21a14 14 0 0 1-13.35-20 10.37 10.37 0 0 1 2.82 2.82c1 1.51 1.61 3.26 2.78 4.64 2.19 2.57 5.92 3.41 9.31 3.26s6.66-1.12 10-1.43c.47 0 .94-.07 1.42-.08a14 14 0 0 1-12.98 10.79zM895.55 690.88a14 14 0 0 1-13.46-19.76 11.48 11.48 0 0 1 3 2.85c1.09 1.54 1.77 3.32 3.05 4.74 2.37 2.63 6.35 3.56 9.93 3.48s6.83-.93 10.28-1.2a14 14 0 0 1-12.8 9.89zM902.48 718.13a14.017 14.017 0 0 1-25.59-11.45 13.84 13.84 0 0 1 3.08 2.75c1.34 1.62 2.22 3.47 3.76 5 2.87 2.82 7.5 4 11.63 4.09a60 60 0 0 0 7.12-.39z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M867.43 738.82s11.08-.34 14.42-2.72 17-5.21 17.86-1.4 16.65 19 4.15 19.06-29.06-1.94-32.4-4-4.03-10.94-4.03-10.94z",
    fill: "#656380"
  }), React.createElement("path", {
    d: "M904.08 752.44c-12.51.1-29.06-1.95-32.39-4-2.54-1.55-3.55-7.09-3.89-9.65h-.37s.7 8.94 4 11 19.89 4.07 32.4 4c3.61 0 4.85-1.31 4.78-3.21-.47 1.12-1.84 1.83-4.53 1.86z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M642 331.03v82.94a19 19 0 0 1-19 19H349.35v-121H623a19 19 0 0 1 19 19.06z",
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 208,
    y: 295,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 208,
    y: 295,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#f2f2f2"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M257 321h93v21h-93z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M257 355h285v11H257zM257 379h114v11H257z"
  }), React.createElement("circle", {
    cx: 92.34,
    cy: 246.84,
    r: 35.75,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M71.6 524.94c3.69 25.89-.81 52.29-7.82 77.48-1.31 4.69-2.72 9.42-5.17 13.63s-5.86 7.83-8.74 11.79c-6 8.26-9.52 18-12.81 27.64a779.65 779.65 0 0 0-22.82 81.32 5.57 5.57 0 0 0 0 3.47c.87 2 3.51 2.26 5.68 2.25l28.06-.15c1-1.92-.85-4-2-5.84-4-6.22-.16-14.3 3.37-20.81a223.74 223.74 0 0 0 19.78-50c1.92-7.33 3.48-14.82 6.6-21.73 3.77-8.38 9.68-15.59 14.48-23.43 5.58-9.11 9.65-19 13.69-28.93 5.64-13.78 11.33-27.73 13.55-42.45 2.09-13.82 1.06-27.9-.3-41.81a2.64 2.64 0 0 0-3.06-3l-37.65-1.94c-7.76-.4-9.6-2.1-8.42 5.52.82 5.69 2.76 11.23 3.58 16.99z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M71.6 524.94c3.69 25.89-.81 52.29-7.82 77.48-1.31 4.69-2.72 9.42-5.17 13.63s-5.86 7.83-8.74 11.79c-6 8.26-9.52 18-12.81 27.64a779.65 779.65 0 0 0-22.82 81.32 5.57 5.57 0 0 0 0 3.47c.87 2 3.51 2.26 5.68 2.25l28.06-.15c1-1.92-.85-4-2-5.84-4-6.22-.16-14.3 3.37-20.81a223.74 223.74 0 0 0 19.78-50c1.92-7.33 3.48-14.82 6.6-21.73 3.77-8.38 9.68-15.59 14.48-23.43 5.58-9.11 9.65-19 13.69-28.93 5.64-13.78 11.33-27.73 13.55-42.45 2.09-13.82 1.06-27.9-.3-41.81a2.64 2.64 0 0 0-3.06-3l-37.65-1.94c-7.76-.4-9.6-2.1-8.42 5.52.82 5.69 2.76 11.23 3.58 16.99z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M79 461.99c-7.65 11-15.67 23.66-13.13 36.83 1.93 10 9.55 17.75 16.74 25 28.74 28.86 57 60.92 66.78 100.47 2.52 10.22 3.74 20.71 5.91 31 3.94 18.7 11 36.58 18 54.35l18.72 47.38a28.36 28.36 0 0 0 27.1-18c-2.46-.19-5.67-2.57-7.11-4.57-8-11.07-9.64-25.31-11.69-38.81-2.27-14.92-5.3-29.72-8.34-44.51l-13.4-65.42c-1.55-7.55-3.1-15.11-5.12-22.54-7.82-28.83-22.64-56-24.93-85.81-.34-4.38-.55-9.19-3.52-12.44-3.12-3.43-8.24-4-12.87-4.27-18.73-1.24-34.89-3.07-53.14 1.34z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M28.47 736.13a29.86 29.86 0 0 0-6.22-.8 12.92 12.92 0 0 0-10.16 5.55 25.25 25.25 0 0 0-2.73 6l-2.71 7.78c-.8 2.28-1.58 4.91-.39 7a7.42 7.42 0 0 0 3.64 2.85c6.56 2.92 13.95 3.08 21.1 3.78 6.94.68 13.82 1.9 20.67 3.19 2.36.44 4.71.89 7.1 1.13 5.34.54 10.72 0 16.06-.48l5.51-.53a19.84 19.84 0 0 0 5.42-1 6.83 6.83 0 0 0 4-3.59c1.36-3.37-1.56-7.36-5.13-8-1.45-.29-2.95-.16-4.42-.35a20.88 20.88 0 0 1-4.84-1.45c-7.05-2.77-14.17-5.57-20.37-9.93-1.72-1.21-3.52-2.9-3.33-5a10.19 10.19 0 0 1 .89-2.59 9.46 9.46 0 0 0 .08-6.69c-.34-.92-1-1.89-1.93-2-2.64-.32-2.32 3.53-2.71 5-.53 2-1.49 2.18-3.37 2-5.4-.58-10.8-.85-16.16-1.87zM186.34 762.96a17.65 17.65 0 0 0 3.82 10.75 8.36 8.36 0 0 0 2.72 2.19 10.92 10.92 0 0 0 4.95.79 40.05 40.05 0 0 0 13.89-2.81 39.7 39.7 0 0 1 4.8-1.81 53.88 53.88 0 0 1 6.24-.9c8.27-1.19 15.53-6.07 23.52-8.54a49.45 49.45 0 0 0 7-2.3c3.16-1.49 5.72-4 8.23-6.43a19.89 19.89 0 0 0 3.78-4.52c1.47-2.74 1.56-6 1.62-9.1a2.59 2.59 0 0 0-.24-1.41 2.1 2.1 0 0 0-.9-.71c-2.43-1.2-5.31-.6-8-.13-9.72 1.73-19.67 1.41-29.54 1.09a4.29 4.29 0 0 1-4.54-2.59l-3.75-6c-1.07-1.72-2.77-3.69-4.71-3.1-1.55.47-2.18 2.37-2.12 4s.56 3.25.25 4.84a6.61 6.61 0 0 1-3.2 4.16 20.44 20.44 0 0 1-5 1.92c-5.52 1.56-11.94 3.33-16.21 7.39-3.09 2.92-2.8 9.37-2.61 13.22z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M184.4 366.26a23.17 23.17 0 0 0 5.46-5.94 24.21 24.21 0 0 0 2.33-8.21l1.57-9.92c.87-5.47 1.89-11.26 5.54-15.43s10.92-5.66 14.63-1.54c1.62 1.79 2.26 4.25 2.66 6.64a48.34 48.34 0 0 1-11.82 40c-4.49 4.92-10 8.83-14.75 13.48-4.14 4-7.73 8.59-11.55 12.94a159.42 159.42 0 0 1-31.47 27.5c.14-7.44 1.09-15.42 0-22.81-.81-5.34-3-8.22 2.17-11.71 12-8.16 24.11-15.54 35.23-25zM83.56 293.08c-.39 5.32-2.6 10.76-7 13.83q18.69 6.54 36.87 14.42c-2.34-2.25-3.05-5.7-3.16-8.94-.31-8.47 2.62-16.8 6.9-24.1a5.85 5.85 0 0 0 1.13-3.18c-.14-2.36-2.94-3.45-5.24-4a128.86 128.86 0 0 0-23.92-3.47c-3.45-.11-7.54-1.2-6.76 3.19.74 4.1 1.49 8.1 1.18 12.25z",
    fill: "#fbbebe"
  }), React.createElement("circle", {
    cx: 107.66,
    cy: 266.7,
    r: 29.23,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M136.6 345.65a35.36 35.36 0 0 0-3.71-6.22c-5.3-7.61-10.74-15.21-17.54-21.51a109.19 109.19 0 0 0-16.65-12.23 37.79 37.79 0 0 0-10.42-5 40.77 40.77 0 0 0-6.69-.91l-7.59-.62a6.21 6.21 0 0 0-2 .06c-2.06.52-3 3.08-2.56 5.15s2 3.75 3.38 5.32c.34 15.49-6.55 30.77-7.48 46.24-1.63 27 14.88 52.21 16.2 79.28a8.55 8.55 0 0 1-.38 3.63c-.22.56-.55 1.07-.8 1.62-.78 1.7-.75 3.63-.89 5.5a27.94 27.94 0 0 1-8.23 17.62 12.23 12.23 0 0 0 4.64 3.54c3.19 1.39 7 1.51 10.39 2.48 8.84 2.58 17.9 5.18 27.09 4.63a23.9 23.9 0 0 0 2.09-7.87c1.3-.81 2.8.92 3 2.44s-.09 3.29 1 4.39 2.47.93 3.8.76c5.61-.71 11-2.6 16.5-3.87s11.38-1.88 16.73-.06c1.08-1.37.62-3.4-.26-4.9s-2.13-2.82-2.63-4.49a10.08 10.08 0 0 1-.32-2.95c0-8.55 1.76-17.19.09-25.58-.49-2.46-1.27-4.86-1.77-7.33-1-4.79-.85-9.73-.72-14.62s-.46-10.18-.56-15.14a48.29 48.29 0 0 0-.4-6.13c-.34-2.13-1-4.21-1.18-6.36-.54-5.46 1.66-10.88 1.33-16.36-.55-8.32-10.22-12.84-13.46-20.51z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M70.63 341.73c-7.08 18.78-10.54 38.7-14 58.48l-8 46.46c-2.27 13.13-4.55 26.34-4.46 39.66 0 3.74.24 7.55-.74 11.16-1.28 4.74-4.46 8.69-6.87 13a42.78 42.78 0 0 0-4.6 28.93c.82 4.15 3.06 8.86 7.27 9.34 3.46.38 6.45-2.37 8.47-5.21 4.64-6.51 6.94-14.37 9-22.11a500.11 500.11 0 0 0 13.87-77.09 75.06 75.06 0 0 1 1.39-9.8 69.54 69.54 0 0 1 3.38-9.76q4.59-11.38 9.19-22.76c7.07-17.53 14.18-35.14 23.89-51.36-9.6-2.76-19.59-6-29.19-8.73-2.77-.82-5.74-.33-8.6-.21z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M87.27 355.97c-6.72-1.45-13.67-1-20.53-1.17a4.43 4.43 0 0 1-2.76-.72c-1.39-1.19-.8-3.42-.1-5.11l3.32-8a11.64 11.64 0 0 1 2.66-4.42c1.69-1.5 4.07-1.87 6.31-2.14 7.29-.84 14.79-1.12 21.86.85s13.72 6.45 16.88 13.08c1.32 2.76 1.93 6.24.18 8.75-2.6 3.73-8.43 7.9-12.78 5.86-5.21-2.44-9.2-5.71-15.04-6.98z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M123 221.3a29.52 29.52 0 0 0-16.28 4.69 35.75 35.75 0 0 0-35.1-8.22A20.43 20.43 0 1 0 48 241.42a35.75 35.75 0 1 0 68.57 20.09 32 32 0 0 0 6.41.65c14.1 0 25.54-9.15 25.54-20.43S137.08 221.3 123 221.3z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M128.09 251.94a31.1 31.1 0 0 1-6.41-.65 35.57 35.57 0 0 1-4.68 10.29 32.11 32.11 0 0 0 6 .58c13.18 0 24-8 25.39-18.24-4.69 4.88-12.04 8.02-20.3 8.02zM87.23 277.51a35.8 35.8 0 0 1-34.18-46.28 20.43 20.43 0 0 1-16.89-20.12 20.09 20.09 0 0 1 .33-3.66 20.43 20.43 0 0 0 11.46 34 35.75 35.75 0 0 0 68.29 21.18 35.68 35.68 0 0 1-29.01 14.88z",
    opacity: 0.1
  }));
};

UndrawNoteList.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawNoteList;